
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11","height":"19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#95a3b0","d":"M4.235 9.779l6.257-6.257a1.737 1.737 0 00-2.457-2.456L.48 8.62a1.636 1.636 0 000 2.315l7.555 7.556a1.737 1.737 0 002.457-2.457z"}})])
          )
        }
      }
    